
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'Cases',
    loading: 'Loading cases...',
    empty: 'No cases available',
    emptyHint: 'They will be back shortly. In the meantime, the other games are open.',
    emptyCta: 'Go to games',
  },
  ru: {
    title: 'Кейсы',
    loading: 'Загрузка кейсов...',
    empty: 'Нет доступных кейсов',
    emptyHint: 'Скоро вернутся. А пока открыты другие игры.',
    emptyCta: 'К играм',
  },
  uz: {
    title: 'Keyslar',
    loading: 'Keyslar yuklanmoqda...',
    empty: 'Mavjud keyslar yoʻq',
    emptyHint: 'Tez orada qaytadi. Hozircha boshqa oʻyinlar ochiq.',
    emptyCta: 'Oʻyinlarga',
  },
  fa: {
    title: 'کیس‌ها',
    loading: 'در حال بارگذاری کیس‌ها...',
    empty: 'کیسی موجود نیست',
    emptyHint: 'به‌زودی برمی‌گردند. تا آن موقع بازی‌های دیگر باز هستند.',
    emptyCta: 'برو به بازی‌ها',
  },
  pt: {
    title: 'Caixas',
    loading: 'Carregando caixas...',
    empty: 'Nenhuma caixa disponível',
    emptyHint: 'Elas voltam em breve. Enquanto isso, os outros jogos estão abertos.',
    emptyCta: 'Para os jogos',
  },
  tr: {
    title: 'Kasalar',
    loading: 'Kasalar yükleniyor...',
    empty: 'Uygun kasa yok',
    emptyHint: 'Yakında geri gelecekler. Bu arada diğer oyunlar açık.',
    emptyCta: 'Oyunlara',
  },
  uk: {
    title: 'Кейси',
    loading: 'Завантаження кейсів...',
    empty: 'Немає доступних кейсів',
    emptyHint: 'Скоро повернуться. А поки відкриті інші ігри.',
    emptyCta: 'До ігор',
  },
  de: {
    title: 'Cases',
    loading: 'Cases werden geladen...',
    empty: 'Keine Cases verfügbar',
    emptyHint: 'Sie sind bald wieder da. Bis dahin sind die anderen Spiele offen.',
    emptyCta: 'Zu den Spielen',
  },
  es: {
    title: 'Cajas',
    loading: 'Cargando cajas...',
    empty: 'No hay cajas disponibles',
    emptyHint: 'Volverán pronto. Mientras tanto, los demás juegos están abiertos.',
    emptyCta: 'A los juegos',
  },
  pl: {
    title: 'Skrzynki',
    loading: 'Wczytywanie skrzynek...',
    empty: 'Brak dostępnych skrzynek',
    emptyHint: 'Wrócą wkrótce. Na razie dostępne są inne gry.',
    emptyCta: 'Do gier',
  },
});
